import { cn } from '@workspace/ui/lib/utils';
import { Icon } from '@/src/components/ui';

type Props = {
  className?: string;
};

export const LoadingOverlay = ({ className }: Props) => (
  <div
    className={cn(
      'absolute inset-0 flex items-center justify-center bg-black/30 rounded-2xl z-30',
      className
    )}
  >
    <Icon name="load" className="absolute size-6 text-white animate-spin" />
  </div>
);
